import { useState } from 'react';
import { IconType } from 'react-icons/lib';
import { Modal, Upload, Button } from 'antd';
import { CloseOutlined, FileDoneOutlined, InboxOutlined } from '@ant-design/icons';
import { RcFile } from 'antd/es/upload/interface';
import './styles.css';

interface UploadModalProps {
    icon: IconType;
    isShowing: boolean;
    isMultiple: boolean;
    acceptTypes: string[];
    toggle: () => void;
    action: (file: Blob[]) => Promise<void>;
}
export function UploadModal({ isShowing, toggle, action, acceptTypes, isMultiple }: UploadModalProps) {
    const [files, setFiles] = useState<RcFile[]>([]);

    const beforeUpload = (file: RcFile, fileList: RcFile[]) => {
        setFiles(isMultiple ? fileList : [file]);
        return false;
    };

    const handleClose = () => {
        setFiles([]);
        toggle();
    }

    const removeFileFromList = (index: number) => {
        let f = files[index];

        setFiles(files.filter(x => x != f));
    }

    return (
        <Modal
            title="Upload de Excel"
            open={isShowing}
            width={800}
            onCancel={handleClose}
            footer={null}
        >
            <Upload.Dragger
                beforeUpload={beforeUpload}
                showUploadList={false}
                className='overflow-x-hidden drag-drop-styles'
                multiple={isMultiple}
                accept={acceptTypes.join(",")}
            >
                <InboxOutlined style={{ fontSize: 40, color: '#2f54eb' }} />
                <div className='d-flex flex-column align-items-center justify-content-center w-100 overflow-x-hidden'>
                    {files.length == 0 ?
                        <>
                            <p className='mb-0'>Clique ou arraste o arquivo para esta área para fazer upload</p>
                            <p className='margin-upload-modal-p'>Só {isMultiple ? "serão aceitos os seguintes tipos:" : "é aceito o seguinte tipo:"} {acceptTypes.join("; ")}</p>
                            <p className='subtitle-upload-drag'>Suporte para upload único ou em massa.</p>
                        </>
                        :
                        <div className='d-flex align-items-center justify-content-center w-100 container-upload-file-list'>
                            {files.slice(0, 4).map((file, i) => {
                                let fileName = "";

                                if (file.name.length > 12) {
                                    let split = file.name.split(".");
                                    fileName = `${file.name.substring(0, 12)}...${split[split.length - 1]}`
                                }

                                return (
                                    <div className='d-flex me-2 ms-2 file-container-upload flex-column align-items-center justify-content-center' title={fileName}>
                                        <div className='w-100 d-flex align-items-center justify-content-end'>
                                            <Button onClick={(e) => { e.stopPropagation(); removeFileFromList(i) }} type='text' color='primary' size='small' icon={<CloseOutlined color='primary' />} />
                                        </div>
                                        <FileDoneOutlined color='primary' />
                                        <span className='mt-2'>{fileName}</span>
                                    </div>
                                )
                            })}
                            {isMultiple && files.length > 4 &&
                                <div className='d-flex me-2 ms-2 file-container-upload flex-column align-items-center justify-content-center' title={files.slice(4).join("\n")}>
                                    <FileDoneOutlined color='primary' />
                                    <span className='mt-2'>+ {files.length - 4}</span>
                                </div>
                            }
                        </div>
                    }
                </div>
            </Upload.Dragger>
            <div className='w-100 d-flex align-items-center mt-4'>
                <Button key="cancel" onClick={handleClose} className='w-50 me-1'>
                    Cancelar
                </Button>
                <Button key="submit" type="primary" disabled={files.length == 0} onClick={() => action(files)} className='w-50 ms-1'>
                    Enviar
                </Button>
            </div>
        </Modal>
    );
}